import { useState } from "react";
import "./index.css";
import { ThemeProvider } from "./context/ThemeContext";
import { AuthProvider }  from "./context/AuthContext";
import { CartProvider }  from "./context/CartContext";
import Navbar                from "./components/Navbar";
import CartDrawer            from "./components/CartDrawer";
import AuthModal             from "./components/AuthModal";
import Toast                 from "./components/Toast";
import HomePage              from "./pages/HomePage";
import RestaurantsPage       from "./pages/RestaurantsPage";
import RestaurantDetailPage  from "./pages/RestaurantDetailPage";
import MenuPage              from "./pages/MenuPage";
import OrdersPage            from "./pages/OrdersPage";
import CheckoutPage          from "./pages/CheckoutPage";

function AppContent() {
  const [activePage, setActivePage]                 = useState("home");
  const [authModal, setAuthModal]                   = useState(null);
  const [selectedRestaurant, setSelectedRestaurant] = useState(null);

  const openAuthModal  = (mode) => setAuthModal(mode);
  const closeAuthModal = ()     => setAuthModal(null);

  const renderPage = () => {
    switch (activePage) {
      case "home":
        return <HomePage setActivePage={setActivePage} />;
      case "restaurants":
        return <RestaurantsPage setActivePage={setActivePage} setSelectedRestaurant={setSelectedRestaurant} />;
      case "detail":
        return <RestaurantDetailPage restaurant={selectedRestaurant} setActivePage={setActivePage} openAuthModal={openAuthModal} />;
      case "menu":
        return <MenuPage openAuthModal={openAuthModal} />;
      case "orders":
        return <OrdersPage openAuthModal={openAuthModal} setActivePage={setActivePage} />;
      case "checkout":
        return <CheckoutPage setActivePage={setActivePage} openAuthModal={openAuthModal} />;
      default:
        return <HomePage setActivePage={setActivePage} />;
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: "var(--bg)" }}>
      <Navbar activePage={activePage} setActivePage={setActivePage} openAuthModal={openAuthModal} />
      <main style={{ paddingTop: "68px" }}>{renderPage()}</main>
      <CartDrawer openAuthModal={openAuthModal} setActivePage={setActivePage} />
      {authModal && <AuthModal mode={authModal} setMode={setAuthModal} onClose={closeAuthModal} />}
      <Toast />
    </div>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <CartProvider>
          <AppContent />
        </CartProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}